import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppTranslationModule } from '../../app.translation.module';
import { CustomFieldsComponent } from './custom-fields/custom-fields.component';
import { CustomFieldsService } from './custom-fields/custom-fields.service';
import { CustomFieldUpdaterService } from './custom-fields/custom-fields-updater.service';
// import { SharedModule, CalendarModule } from 'primeng/primeng';
import { PasswordComplexityComponent } from './password-complexity/password-complexity.component';

//Following modules need to move common module -- Added by Anvardeen Batcha
import { PartRequestComponent } from './part/part-requset';
import { PartRequestAddEditComponent } from './part/add-edit-part-request.component';
import { PartLookupComponent } from './part/part-lookup.component';
import { SerialNumberLookupComponent } from './part/serial-number-lookup.component';
import {
    DataTableModule, PanelModule, SharedModule, InputMaskModule, CalendarModule, TooltipModule,
    MultiSelectModule, PickListModule, FileUploadModule, AutoCompleteModule, SplitButtonModule, OverlayPanelModule,
    PaginatorModule, CarouselModule, DialogModule, RadioButtonModule, ConfirmDialogModule, ConfirmationService, AccordionModule, ListboxModule, EditorModule, RatingModule
} from 'primeng/primeng';
import {TableModule} from 'primeng/table';
import { DatepickerModule, TooltipModule as TooltipModuleBootstrap, PopoverModule } from 'ngx-bootstrap';
import { CoreModule } from '../core/core.module';
import { FPAutofocus } from './auto-focus.directive';

import { SlaDetailsComponent } from './sla-details/sla-details.component';
import { SlaDetailPopupComponent } from './sla-details/sla-detail-popup.component';
import { EditSlaDetailPopUpComponent } from './sla-details/edit-sla-detail-popup.component';
import { CountdownTimerComponent } from './custom-controls/countdown-timer/countdown-timer.component';

//Following modules need to move common module -- Added by Anvardeen Batcha
import { AssignVendorComponent } from './assign-vendor/assign-vendor.component';
import { PrintAllNotesComponent } from './print-notes//print-all-notes.component';
import { ImagePreviewComponent } from './image-preview/image-preview.component';
import { imagezoom } from './image-preview/image-zoom';

//End Following modules need to move common module -- Added by Anvardeen Batcha

import { AssetTransferHistoryPopupComponent } from './asset-transferhistory/assettransfer-history-popup.component';
import { jobEmailComponent } from './job-email/job-email.component';
import { TechnicianJobService } from '../technician/technician-jobs/technician-jobs.service';
import { PartAttachementComponent } from './part/part-attachement-lookup-component';
import { CapitalizeFirstPipe } from '../shared/pipes/custom-pipes.pipe';
import { PartService } from "app/layout/inventory/part/part.service";
import { JobPrintPreviewComponent } from './print-preview/print-preview.component';
import { GpsLocationPopupComponent } from './gps-location/gps-location-popup.component';
import { RejectApprovalComponent } from './reject-approval/reject-approval.component';
import { ApprovalQueueService } from '../queues/approval-queue/approval-queue.service';
import { CustomerEditComponent } from './customer-create-edit/customer-edit.component';
import { CustomerService } from '../customer/customer.service';
import { DynamicFormsChecklistComponent } from './dynamic-forms/dynamic-forms-checklist.component';
import { addattachmentpopup } from './dynamic-forms/Checklist-Attachment/addattachment-popup.component';
import { NgxGalleryModule } from 'ngx-gallery';//Email job Component

import { MetadataInfoPopupComponent } from './metadata/metadata-info-popup.component';
import { ConfirmPopupComponent } from './confirm-popup.component';
import { BOQPartRequestAddEditComponent } from './part/add-edit-boq-part-request.component';
import { smsPopupComponent } from './sent-mail/sms-popup.component';
import { viewEmailComponent } from './sent-mail/email-popup.component';
import { SentMailPopupComponent } from './sent-mail/sent-mail-popup.component';
import { TextChatPopupComponent } from '../text-chat/textchat-popup.component';
import { TextChatService } from '../text-chat/textchat.service';
import { DataPassingService } from '../text-chat/data-passing.service';
import { VideoChatService } from '../dispatch/video-chat/video-chat.service';
import { FPTextChatPopupComponent } from '../fp-text-chat/fp-textchat-popup.component';
import { FPDataPassingService } from '../fp-text-chat/fp-data-passing.service';
import { FPTextChatService } from '../fp-text-chat/fp-textchat.service';
import { Ng2CableModule } from 'ng2-cable';
import { ProjectDetailPanelComponent } from './project/project-details-panel.component';
import { SafeUrlPipe  } from '../shared/pipes/safe-url.pipe';
import { AddPunchAttachmentComponent } from './punch-attachment/add-punch-attachment.component'
import { WoJobPrintPreviewComponent } from './wo-print-preview/wo-print-preview.component';
import { CustomersSearchComponent } from './wo-customer-lookup/work-customer-search.component';
import { SerialNumberAddEditLookupComponent } from './part/add-edit-serial-number-lookup.component';
import { TechProfilePicComponent } from './tech-profile-pic/tech-profile-pic.component' // Added for Edotco Specific by KP on 13/Aug/20
import { MapLookUpComponent } from './map-lookup/map-lookup.component' 
import { JobstatuspopupComponent } from './wo-status-map/work-order-statuspopup';
import { AddSiteComponent } from './add-site/add-site.component';
import { AddCustomerComponent } from './add-site/add-customer/add-customer.component';
import { VendorAcceptReject } from './vendor-approve-reject/vendor-approve-reject.component';
import { JobPrintPreviewProComponent } from './print-preview-pro/print-preview-pro.component';
import { ProductCategoryAddEditComponent } from './product-category/product-category-add-edit.component';
import { ContractTypeAddEditComponent } from './add-equiment/contract-type-add-edit.component';
import { TechnicianPopupComponent } from './technician-popup/technician-popup.component';
import { CustomerMultipleLoginEditComponent } from './customer-create-edit/customer-multiplelogin-edit.component';


@NgModule({
    imports: [

        CommonModule,
        FormsModule,
        AppTranslationModule,
        ReactiveFormsModule,
        SharedModule,
        CalendarModule,
        //Following modules need to move common module -- Added by Anvardeen Batcha
        DataTableModule,
        TableModule,
        PanelModule,
        CoreModule,
        InputMaskModule,
        DatepickerModule,
        MultiSelectModule,
        AutoCompleteModule,
        PaginatorModule,
        CarouselModule,
        DialogModule,
        RadioButtonModule,
        ConfirmDialogModule,
        PickListModule,
        FileUploadModule,
        ListboxModule,
        TooltipModuleBootstrap.forRoot(),
        TooltipModule,
        PopoverModule.forRoot(),
        AccordionModule,
        SplitButtonModule,
        OverlayPanelModule,
        AppTranslationModule,
        EditorModule,
        NgxGalleryModule,
        Ng2CableModule,
        RatingModule
        //End Following modules need to move common module -- Added by Anvardeen Batcha
    ],
    declarations: [
        CustomFieldsComponent,
        PasswordComplexityComponent,SafeUrlPipe,
        //Following modules need to move common module -- Added by Anvardeen Batcha
        PartRequestComponent, PartRequestAddEditComponent, PartLookupComponent, SerialNumberLookupComponent, FPAutofocus,
        SlaDetailsComponent, SlaDetailPopupComponent, EditSlaDetailPopUpComponent, CountdownTimerComponent, AssignVendorComponent, PrintAllNotesComponent, AssetTransferHistoryPopupComponent, ImagePreviewComponent, imagezoom,
        //End Following modules need to move common module -- Added by Anvardeen Batcha
        jobEmailComponent, PartAttachementComponent, CapitalizeFirstPipe, JobPrintPreviewComponent, GpsLocationPopupComponent, RejectApprovalComponent,
        CustomerEditComponent, DynamicFormsChecklistComponent, addattachmentpopup,
        MetadataInfoPopupComponent,
        ConfirmPopupComponent,
        BOQPartRequestAddEditComponent,
        smsPopupComponent, viewEmailComponent, SentMailPopupComponent, TextChatPopupComponent,
        FPTextChatPopupComponent,
        ProjectDetailPanelComponent,
        AddPunchAttachmentComponent,
        WoJobPrintPreviewComponent,
        CustomersSearchComponent,
        SerialNumberAddEditLookupComponent,
        TechProfilePicComponent,        
        MapLookUpComponent,
        JobstatuspopupComponent,
        AddSiteComponent,
        AddCustomerComponent,
        VendorAcceptReject,
        JobPrintPreviewProComponent,
        ProductCategoryAddEditComponent,
        ContractTypeAddEditComponent,
        TechnicianPopupComponent,
        CustomerMultipleLoginEditComponent // Elixir specific multiple login for customer
        /*TextChatPopupComponent*/
    ],

    exports: [CustomFieldsComponent, PasswordComplexityComponent,SafeUrlPipe,AddPunchAttachmentComponent,WoJobPrintPreviewComponent,
        //Following modules need to move common module -- Added by Anvardeen Batcha
        PartRequestComponent, PartRequestAddEditComponent, PartLookupComponent, SerialNumberLookupComponent, FPAutofocus,TechnicianPopupComponent, /* TextChatPopupComponent,*/
        SlaDetailsComponent, SlaDetailPopupComponent, EditSlaDetailPopUpComponent, smsPopupComponent, CountdownTimerComponent, AssignVendorComponent, PrintAllNotesComponent, AssetTransferHistoryPopupComponent, ImagePreviewComponent, jobEmailComponent, PartAttachementComponent, JobPrintPreviewComponent, GpsLocationPopupComponent, RejectApprovalComponent, CustomerEditComponent, DynamicFormsChecklistComponent, MetadataInfoPopupComponent, ConfirmPopupComponent, SentMailPopupComponent, viewEmailComponent, TextChatPopupComponent, FPTextChatPopupComponent, ProjectDetailPanelComponent,
        CustomersSearchComponent,SerialNumberAddEditLookupComponent,TechProfilePicComponent,ProductCategoryAddEditComponent,ContractTypeAddEditComponent
        ,SerialNumberAddEditLookupComponent,MapLookUpComponent,JobstatuspopupComponent,AddSiteComponent,VendorAcceptReject,JobPrintPreviewProComponent
    ],
    //End Following modules need to move common module -- Added by Anvardeen Batcha
    providers: [
        CustomFieldsService, CustomFieldUpdaterService, TechnicianJobService, PartService, ApprovalQueueService, CustomerService,
        ConfirmationService, TextChatService, DataPassingService, VideoChatService /*TextChatService*/, FPDataPassingService, FPTextChatService
    ],
})
export class ShareModule { }